import { useMemo } from 'react';
import PropTypes from 'prop-types';
import { Tabs } from 'antd';
import { renderTabBarProducts } from 'components/MarkupAndBaseRateStyledWrapper/MarkupAndBaseRateStyledWrapper';
import ProductTemplate from './ProductTemplate';

function ProductTab({ products, initial }) {
  const productTabItems = useMemo(() => {
    return (
      products?.map((x, i) => ({
        key: `${i}`,
        label: x?.product_name,
        children: (
          <ProductTemplate
            product={x?.product_name}
            configuration={x?.configuration}
            initial={initial[x?.product_name]}
          />
        )
      })) || []
    );
  }, [products, initial]);

  return (
    <Tabs
      defaultActiveKey="0"
      size="large"
      items={productTabItems}
      type="card"
      tabBarGutter={8}
      renderTabBar={renderTabBarProducts}
      style={{ marginTop: '15px' }}
    />
  );
}

ProductTab.propTypes = {
  products: PropTypes.arrayOf(
    PropTypes.shape({
      product_name: PropTypes.string,
      configuration: PropTypes.instanceOf(Array).isRequired
    })
  ).isRequired,
  initial: PropTypes.instanceOf(Object).isRequired
};

export default ProductTab;
